<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css" />

<!--Main Content-->
<div class="element">
  
    <div class="background">

      <div class="fontsize">
        <p>Use the&nbsp;&nbsp;</p>
        <p>
          <i class="far fa-user-circle"></i>
        </p>
        <p>&nbsp;&nbsp;icon on the right to login</p>
      </div>

      <div>
        <img src="assets/images/dreieckelinks.svg" alt="image description" class="left-align">
      </div>

      <div>
        <img src="assets/images/dreieckerechts.svg" alt="image description" class="rigth-align">
      </div>

      <div>
        <img src="assets/images/RasterSponsoren.svg" alt="image description" class="sponsoren">
      </div>
    </div>


    <div class="center-container">
      <img src="assets/images/tag.svg" alt="Logo" class="tag" width="500" height="500">
      <img src="assets/images/NEONE_Logo.svg" alt="Logo" class="logo">
    </div>

 
</div>
